const AuthenticationStyle = (theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    fontFamily: "Montserrat !important",
    minWidth: "initial",
  },
  navbar: {
    display: "flex",
    backgroundColor: "white",
    boxShadow: "0px 5px #c2c5c4",
    height: "60px",
    overflow: "hidden",
    borderBottom: "2px solid grey",
  },
  newbtn: {
    position: "absolute",
    width: "max-content",
    color: "black !important",
    "font-size": "small !important",
    textTransform: "none !important",
    fontFamily: "Montserrat !important",
  },
  nav_gap: {
    flexbasis: "auto !important",
    color: "black !important",
  },
  nav_align: {
    paddingTop: "10px",
  },
  btn_navbar: {
    textAlign: "center",
  },
  location: {
    height: "30px",
  },
  locIcon: {
    height: "16px !important",
    color: "#D99F12",
  },
  searchInput: {
    borderRadius: '9px !important',
    fontFamily: "Montserrat !important",
    fontSize: '13px',
    color: '#131C4C !important',
    height: '62px',
    fontWeight: 400,
    '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #BCC0D5 !important',
    },
    "& input::placeholder": {
        color: "#131C4C",
        opacity: '1'
    },
  },
  coperate_start: {
    background: " url(./Images/u.png)",
    justifyContent: "center",
  },
  coperate_start2: {
    background: " url(./Images/rt.png)",
    justifyContent: "center",
    paddingTop: "40px",
    display: "block",
    "@media (max-width: 600px)": {
      padding: "30px"
  
  }
  },
  coperate_start3: {
    background: " url(../Images/rt.png)",
    justifyContent: "center",
    paddingTop: "50px",
  },
  purpdts: {
    fontSize: "15px",
    color: "#545A77",
    opacity: "1",
    fontWeight: "300 !important",
    lineHeight: "24px",
  },
  navicon:{
    display:"none",
    marginLeft: "0px",
    "@media (max-width: 900px)": {
      
      display:"flex",
  },
    "@media (max-width: 330px)": {
      marginLeft: "-50px"
  
  }
  },
  changedPass:{
    "@media (max-width: 600px)": {
      marginLeft: "0px !important"
  
  }
  },
  purpdata: {
    color: "#131C4C",
    opacity: "0.9",
    lineHeight: "40px",
  },
  purpwhy: {
    color: "#131C4C",
    opacity: "1",
    fontWeight: "700",
    "@media (max-width: 600px)": {
      marginLeft: "69px"
  
  }
  },
  coperate_section: {
    padding: "35px",
  },
  coperate_btn: {
    height: "40px",
    width: "150px",
    fontSize: "13px",
    color: "#62AF4B",
    fontFamily: "Montserrat",
    "@media (max-width: 600px)": {
      height: "10px",
    
    }
  },
  services_coperate_btn:{
    height: "40px",
    width: "150px",
    fontSize: "13px",
    color: "#62AF4B",
    fontFamily: "Montserrat",
    "@media (max-width: 600px)": {
      marginLeft:"10%",
    
    }
  },
  msg_icon: {
    height: "15px !important",
    paddingLeft: "10px",
    
  },
  input: {
    //border:"solid 1px rgba(0, 0, 0, 0.42)",
    transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

    display: "flex !important",
    width: "330px",
    marginTop: "10px",
    backgroundColor: "white",
    height: "62px",
    border: "1px solid #BCC0D5",
    borderRadius: "9px",

    "&:before": {
      borderBottom: "0px !important",
      color: "#BCC0D5",
    },
    "&:after": {
      borderBottom: "0px !important",
    },
    "&:hover": {
      border: "1px solid #4F61C1",
    },
    "&:focus": {
      border: "1px solid #4F61C1",
    },
    "@media (max-width: 600px)": {
      width: "110%",
    
    },
    "@media (max-width: 900px)": {
      width: "100%",
    
    },
    "@media (max-width: 320px)": {
      width: "110%",
    
    }
  },

  login: {
    width: "145px",
    height: "62px",
    color: "white",
    background: "#131C4C no-repeat",
    borderRadius: "9px",
    cursor: "pointer",
    fontSize:"15px",
    fontWeight:"700"
  },
  loginButtonDis:{
    opacity:'0.5',
    width: "145px",
    height: "62px",
    color: "white",
    background: "#131C4C no-repeat",
    borderRadius: "9px",
    cursor: "pointer",
  },
  login4: {
    width: "255px !important",
    height: "62px !important",
    color: "white !important",
    background: "#131C4C no-repeat !important",
    borderRadius: "9px !important",
    cursor: "pointer !important",
    fontSize:"15px !important",
    fontWeight:"700 !important"
  },


  login2: {
    width: "145px",
    height: "62px",
    color: "white",
    background: "#131C4C no-repeat",
    borderRadius: "9px",
    cursor: "pointer",
   
  },
  share: {
    width: "48px",
    height: "48px",
    
    borderRadius: "9px",
    cursor: "pointer",
  },
  share_style: {
    gap: "35px",
  },
  extra_login: {
    display: "flex",
    gap:"10px"
  
   
  },
  extra_login_btn: {
    width: "100%",
    backgroundColor: "black",
    color: "white",
    height: "32px",
  },

  flow: {
    backgroundColor: "#131C4C",
    color: "white",
  },
  services_background: {
    backgroundColor: "#FFFFFF",
    paddingTop: "40px",
    paddingBottom: "40px",
    width: "100%",
    "@media (max-width: 600px)": {
      paddingTop: "20px",
      paddingBottom: "20px",
    }
  },
  services: {
    textAlign: "center",
    fontSize: "38px",
    fontWeight: "700",
    fontFamily: "Montserrat",
    marginTop: "30px",
    "@media (max-width: 600px)": {
      fontSize: "26px",
      fontWeight: "600",
  
  }
  },
  services_desc: {
    display: "flex",
    padding: "50px",
    fontFamily: "Montserrat;",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "@media (max-width: 600px)": {
      padding: "20px",
      justifyContent: "center",
    }
  },
  ht: {
    maxWidth: "1280px",
    margin: "auto",
  },
  ht1: {
    maxWidth: "1280px",
    margin: "auto",
    boxShadow: "0px 2px 2px -6px #0000001a",
  },
  services_desc_pur: {
    display: "flex",
    padding: "50px",
    fontFamily: "Montserrat;",
    justifyContent: "space-between",
  },
  services_heading: {
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: "Montserrat;",
    paddingRight: "35px",
    paddingBottom: "5px",
    wordBreak: "keep-all",
    color: "#131C4C",
    opacity: "1",
  },
  services_heading: {
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: "Montserrat;",
    paddingRight: "35px",
    paddingBottom: "5px",
    wordBreak: "keep-all",
    color: "#131C4C",
    opacity: "1",
    "@media (max-width: 600px)": {
      marginTop:"60px",
      marginLeft:"50px",
      fontSize: "16px",
      width:"147px"
   
   }
  },
  services_headingI: {
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: "Montserrat;",
    paddingRight: "35px",
    paddingBottom: "5px",
    wordBreak: "keep-all",
    color: "#131C4C",
    opacity: "1",
    "@media (max-width: 600px)": {
     marginTop:"50px",
     marginLeft:"50px",
     fontSize: "16px",
     width:"147px"
  
  }

  },
  iconed: {
    paddingTop: "10px",
    "@media (max-width: 600px)": {
      paddingTop: "5px",
  
  }
  },
  flow_heading: {
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: "Montserrat",
    "@media (max-width: 600px)": {
 marginLeft:"50px",
 
 marginTop:"20px",
 fontSize: "16px",
 width:"147px",
   }
  },
  askQuestion:{
    "@media (max-width: 600px)": {
    display:"flex",
  justifyContent:"center"
  }
  },
  imgAsk:{
    "@media (max-width: 600px)": {
    width:"50%"
    
    }
  },
  purpose: {
    margin: "30px",
  },
  purpose_heading: {
    fontWeight: "600",
    fontSize: "23px",
    fontFamily: "Montserrat",
  },
  asked_heading: {
    fontSize: "40px",
    fontWeight: "700",
    fontFamily: "Montserrat;",
    "@media (max-width: 600px)": {
      fontSize: "25px",
      fontWeight: "700",
      color:"#131C4C",
      marginTop:"30px",
      marginBottom:"20px",
      wordBreak: "keep-all"
  }
  },
  freq_heading: {
    fontWeight: "700",
    padding: " 10px",
    fontFamily: "Montserrat;",
  },
  freq_desc: {
    /*
        backgroundColor: "#131C4C",*/
    color: "white",
  },
  freq_list: {
    backgroundColor: "#F2F8FD",
    "&:hover": {
      backgroundColor: "#F2F8FD",
      marginRight:"35px"
    },
  },

  frq: {
    fontFamily: "Montserrat !important",
    color: "#131C4C !important",
    fontSize: "24px",
    fontWeight: "700",
  },
  services_content: {
    wordBreak: "break-all",
  },
  services_details: {
    paddingRight: "30px",
    wordBreak: "break-all",
    color: "grey",
    fontSize: "15px",
    wordBreak: "keep-all",
    paddingTop: "5px",
  },
  package: {
    height: "90px",
    marginBottom: "10px",
    "@media (max-width: 600px)": {
      marginTop: "40px",
     height:"80px"
  
  }
  },
  img_box:{
    "@media (max-width: 600px)": {
      
      width:"50px"
  
  }
  },
  upper_portion:{
    "@media (max-width: 600px)": {
    display:"flex",
    justifyContent:"flex_start",
  }
  },
  upper_flow_portion:{
    "@media (max-width: 600px)": {
    display:"flex",
  justifyContent:"flex_start",
  marginTop:"50px"
  }
  },
  flow_package: {
    height: "70px",
    marginBottom: "10px",
  },
  choose_img: {
    width: "80%",
  },
  askedQuest: {
    backgroundColor: "#F2F8FD",
    padding: "10px",
  },
  payment: {
    background: " url(./Images/bg-3.png)",
  },
  Allservice: {
    display: "grid",
    gap: "20px",
    "@media (max-width: 600px)": {
marginLeft:"5%",
width:"90%"
    }
  },
  service_bg: {
    paddingLeft: "50px",
    width: "600px",
    paddingBottom: "40px",
    height: "500px",
    "@media (max-width: 600px)": {
      objectFit:"contain",
      height: "400px",
      paddingLeft: "0px",
      width:"auto"
    },
    "@media (max-width: 350px)": {
      width: "250px",
      height: "350px",
      paddingLeft: "0px",

    }
  },
  btn_dash: {
    width: "100%",
    borderRadius: "9px",
    border: "1px solid #BCC0D5;",
    height: "38px",
    cursor: "pointer",
    background: "#FFFFFF",
    color: "black",
    display: "inline-flex"
  },
  para_dash: {
    fontSize: "10px",
    padding: "5px",
    fontFamily: "Montserrat",
    color: "#131C4C",
  },
  service_btn: {
    display: "flex",
    justifyContent: "space-between",
    height: "48px",
    //width:"300px",
    backgroundColor: "#141C4B",
    border: "1px solid #BCC0D5",
    borderRadius: "9px",
    color: "white",
    textAlign: "left",
    padding: "15px",
    cursor: "pointer",
    "@media (max-width: 600px)": {
      width:"90%",
      marginLeft:"5%",
      
  }
  },
  service_image: {
    textAlign: "right",
  },
  service_img_dash: {
    textAlign: "right",
    color: "#141C4B",
    marginLeft: "70px",
    "@media (max-width: 600px)": {
      marginLeft: "50px",
      textAlign: "left",
  },
  "@media (max-width: 350px)": {
    marginLeft: "10px",
    textAlign: "left",
}
  },
  section_start: {
    padding: "50px;",
  },
  footer_back: {
    backgroundColor: "#131C4C",
    color: "white",
  },
  footer_head: {
    // marginLeft: "50px",
    marginTop: "20px",
    fontWeight: "700",
    fontFamily: "Montserrat",
    fontSize: "36px",
    marginLeft:"4%",
    "@media (max-width: 600px)": {
      display:"flex",
      justifyContent:"space-around"
  
  }
  },
  forgetAlign:{
    display:"flex",
    justifyContent:"space-between",
    width:"115%",
    "@media (max-width: 1000px)": {
      width:"107%",
  
  },
    "@media (max-width: 600px)": {
      width:"107%",
  
  }
},
// start_track: {
  
//   background: "url(./Images/banner.png)",
// },
send_label: {
  fontFamily: "Montserrat !important",
  fontSize: "14px",
  color: "#131C4C",
  fontWeight: "700",
  paddingBottom: "10px",
  display:"flex",
  justifyContent:"space-between",
  cursor:"pointer",
  "@media (max-width: 600px)": {
      flexDirection:"column"
  }
},
  footer_desc: {
    display: "block !important",
    fontSize: "13px",
    lineHeight: "24px",
    color: "#8F92A3",
    "@media (max-width: 600px)": {
      marginTop:"20px",
  
  }
  },
  footer_descbtn: {
    display: "block !important",
    fontSize: "13px",
    lineHeight: "24px",
    color: "#8F92A3",
    textTransform:'none',
    paddingLeft:'0px !important'
  },
  footer_desc1: {
    display: "block !important",
    fontSize: "10px",
    lineHeight: "18px",
  },
  descfot: {
    color: "#8F92A3 !important",
    fontSize: "13px",
  },
  footer_img: {
    height: "40px",
  },
  start:{
    display:'flex'
  },
  footer_img: {
    height: "40px",
    "@media (max-width: 600px)": {
     
  
  }
  
  },
  footer_img_small: {
    height: "30px",
  },
  country:{
  
    
    "@media (max-width: 600px)": {
      display:"flex",
      flexDirection:"row",
      flexWrap: 'wrap'
  }
  },
  single_country:{
    "@media (max-width: 600px)": {
     marginRight:"40px",
      flexWrap: 'wrap'
  
  }
  },
  single_service:{
    "@media (max-width: 600px)": {
      marginRight:"20px",
       flexWrap: 'wrap',
   
   }
  },
  our_service:{
    "@media (max-width: 600px)": {
      display:"flex",
      flexDirection:"row",
      flexWrap: 'wrap',
  }
  },
  field_margin:{
    "@media (max-width: 600px)": {
marginTop:"20px",

  }
  },
  small: {
    display: "flex",
    marginTop: "10px",
  },
  smallContent: {
    padding: "5px",
    fontSize: "13px",
    "@media (max-width: 600px)": {
      marginBottom:"10px",
      
        }
  },
  errorVal: {
    color: "Red",
    fontSize: "small",
  },
  personel: {
    marginTop: "5px",
  },
  das: {
    width: "30%",
  },
  dashb: {
    display: "flex",
    justifyContent: "center",
    marginTop: "70px",
  },
  dashbtext: {
    display: "flex",
    justifyContent: "center",
  },
  dbtn: {
    height: "40px",
    width: "150px",
    color: "#FFFF",
    backgroundColor: "#141C4B",
    cursor: "pointer",
  },
  drp: {
    fontFamily: "Montserrat !important",
    color: "#6E759A !important",
    fontSize: "13px !important",
  },
  sepa: {
    maxWidth: "1280px",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
  },
  separt: {
    width: "100px",
    paddingTop: "15px",
  },
  ared: {
    width: "15px",
    paddingTop: "3px",
  },
  or_align:{
    display:"flex",
    justifyContent:"center",
   marginLeft:"67px",
   marginTop:"-5px",
   marginBottom:"20px",
   "@media (max-width: 600px)": {
      marginLeft:"30px",
  
  }
  },
  section_start: {

    fontFamily: "Montserrat !important"
},
trackCont:{
  background:"white",
  height:"100px"
},
contentTrack:{

    paddingTop: "70px",
    "@media (max-width: 600px)": {
        paddingTop: "0px",
    }


},
newbg: {
    background: "url(./Images/banner.png)",
    height: "420px",
    backgroundSize: 'contain',
    backgroundPosition: 'top',
    backdropFilter: 'blur(3px)'
},
newbgTrack: {
  height: "100px",
  backgroundSize: 'contain',
  backgroundPosition: 'top',
  backdropFilter: 'blur(3px)'
},
service_btnTrack: {
  height: "74px",
  width: "100%",
  backgroundColor: "#131C4C",
  border: "1px solid #BCC0D5",
  borderRadius: "9px",
  color: "white",
  padding: "24px",
  cursor: "pointer",
  textAlign: "center",
  fontFamily: 'Montserrat',
  fontSize: '22px',
  fontWeight: 600,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
},
service_btnReset: {
  height: "74px",
  width: "100%",
  backgroundColor: "white",
  border: "1px solid #BCC0D5",
  borderRadius: "9px",
  color: "#131C4C",
  padding: "24px",
  cursor: "pointer",
  textAlign: "center",
  fontFamily: 'Montserrat',
  fontSize: '22px',
  fontWeight: 600,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
},
secn: {
    paddingTop: "40px",
    /* background: " url(./Images/rt.png)",*/

},
ht: {
    maxWidth: "1280px",
    margin: "auto",
    // paddingLeft: "50px",
    "@media (max-width: 600px)": {
        maxWidth: "600px",
        paddingLeft: "20px",
    }
},
htTracked:{
  display:"flex",
  maxWidth: "1280px",
  borderRadius: "16px",
  background: "#F9F9F9",
  margin: "auto",
  paddingLeft: "50px",
  paddingRight: "30px",
  "@media (max-width: 600px)": {
      maxWidth: "600px",
      paddingLeft: "20px",
  }
},
newbgIot: {
  background: "url(./Images/banner.png)",
 //background: "#ffff",
  backgroundSize: 'contain',
  backgroundPosition: 'top',
  backdropFilter: 'blur(3px)',
  display: "flex"
},
htTrack:{
  maxWidth: "1280px",
  margin: "auto",
 
  "@media (max-width: 600px)": {
      maxWidth: "600px",
      paddingLeft: "20px",
  }
},
heading: {
    fontWeight: "700",
    fontSize: "20px",
    display: "flex",
    "@media (max-width: 600px)": {
        fontWeight: "500",
    
    }
},
vat: {
    fontSize: "15px",
    color: "#545A77",
    paddingBottom: "50px",
    paddingTop: "17px",
    paddingLeft: '100px',
    lineHeight: '24px',
    "@media (max-width: 600px)": {
        paddingLeft: '0px',
    
    }
},
send_header: {
    marginTop: "45px",
    "@media (max-width: 600px)": {
        marginRight:"10%"
    
    }
},
send_img: {
    height: "87px",
    cursor: "pointer",
    "@media (max-width: 600px)": {
        width:"30%"
    
    }
},
send_bg: {
    paddingBottom: "20px",
    maxWidth: "1280px",
    margin: "auto"
},
send_heading: {
    fontSize: "44px",
    fontWeight: "bold",
    marginTop: "20px",
    "@media (max-width: 600px)": {
        fontSize: "24px",
    color:"#131C4C"
    }
},
});

export default AuthenticationStyle;
